import { SelfDescribingJson } from '@snowplow/browser-tracker';

import {
  CollaborationContext,
  DesignContext,
  ElementContext,
  FunnelContext,
  GeniallyContext,
  InspirationContext,
  InteractivityContext,
  mapAmountOfSelectedItemsContext,
  mapCollaborationContext,
  mapDesignContext,
  mapElementContext,
  mapFunnelContext,
  mapGeniallyContext,
  mapInspirationContext,
  mapInteractivityContext,
  mapOldPlanContext,
  mapPaymentContext,
  mapPlanContext,
  mapPlayContext,
  mapSpaceContext,
  mapSwitchContext,
  mapTeamSubscriptionContext,
  mapTemplateContext,
  mapTemplateFiltersContext,
  mapTriggerContext,
  mapUserContext,
  mapWorkspaceContext,
  mapWorkspaceMemberContext,
  OldPlanContext,
  PaymentContext,
  PlanContext,
  PlayContext,
  SpaceContext,
  SwitchContext,
  TeamSubscriptionContext,
  TemplateContext,
  TemplateFiltersContext,
  TriggerContext,
  UserContext,
  WorkspaceContext,
  WorkspaceMemberContext,
} from '@genially/snowplow-contracts';

export const mapAllContextsAsArray = ({
  amountOfSelectedItems,
  collaboration,
  design,
  element,
  funnel,
  genially,
  inspiration,
  interactivity,
  oldPlan,
  payment,
  plan,
  space,
  switchValue,
  team,
  teamMember,
  teamSubscription,
  template,
  templateFilters,
  trigger,
  user,
  play,
}: {
  amountOfSelectedItems?: number;
  collaboration?: CollaborationContext;
  play?: PlayContext;
  design?: DesignContext;
  element?: ElementContext;
  funnel?: FunnelContext;
  genially?: GeniallyContext;
  inspiration?: InspirationContext;
  interactivity?: InteractivityContext;
  oldPlan?: OldPlanContext;
  payment?: PaymentContext;
  plan?: PlanContext;
  space?: SpaceContext;
  switchValue?: SwitchContext;
  team?: WorkspaceContext;
  teamMember?: WorkspaceMemberContext;
  teamSubscription?: TeamSubscriptionContext;
  template?: TemplateContext;
  templateFilters?: TemplateFiltersContext;
  trigger?: TriggerContext;
  user?: UserContext;
}): SelfDescribingJson<Record<string, unknown>>[] | undefined => {
  const contexts = [
    amountOfSelectedItems !== undefined
      ? mapAmountOfSelectedItemsContext(amountOfSelectedItems)
      : undefined,
    collaboration ? mapCollaborationContext(collaboration) : undefined,
    design ? mapDesignContext(design) : undefined,
    element ? mapElementContext(element) : undefined,
    funnel ? mapFunnelContext(funnel) : undefined,
    genially ? mapGeniallyContext(genially) : undefined,
    inspiration ? mapInspirationContext(inspiration) : undefined,
    interactivity ? mapInteractivityContext(interactivity) : undefined,
    oldPlan ? mapOldPlanContext(oldPlan) : undefined,
    payment ? mapPaymentContext(payment) : undefined,
    plan ? mapPlanContext(plan) : undefined,
    space ? mapSpaceContext(space) : undefined,
    switchValue ? mapSwitchContext(switchValue) : undefined,
    team ? mapWorkspaceContext(team) : undefined,
    teamMember ? mapWorkspaceMemberContext(teamMember) : undefined,
    teamSubscription ? mapTeamSubscriptionContext(teamSubscription) : undefined,
    template ? mapTemplateContext(template) : undefined,
    templateFilters ? mapTemplateFiltersContext(templateFilters) : undefined,
    trigger ? mapTriggerContext(trigger) : undefined,
    user ? mapUserContext(user) : undefined,
    play ? mapPlayContext(play) : undefined,
  ];

  const finalContexts = contexts.filter(context => !!context);

  return !finalContexts.length
    ? undefined
    : (finalContexts as SelfDescribingJson<Record<string, unknown>>[]);
};
